import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import CopilotDrawer from "./CopilotDrawer";
import kvsLogo from "../assets/kvsLogo.svg";


const FloatingAIButton: React.FC = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  // Hide the FAB entirely when the full copilot page is open
  if (location.pathname.startsWith("/analytics")) return null;

  return (
    <>
      {/* Drawer panel */}
      <CopilotDrawer isOpen={open} onClose={() => setOpen(false)} />

      {/* Floating toggle button — always above the drawer (z-[65]) */}
      <div className="fixed bottom-8 right-8 z-[65] flex flex-col items-center gap-2 select-none">

        {/* Tooltip — shown only when closed and hovered via CSS group */}
        {!open && (
          <div className="group/fab flex flex-col items-center gap-2">
            {/* Tooltip */}
            <div className="opacity-0 group-hover/fab:opacity-100 transition-opacity duration-150
              pointer-events-none mb-1">
              <div className="bg-gray-900 text-white text-xs font-medium px-3 py-1.5 rounded-lg
                whitespace-nowrap shadow-lg relative">
                Samiksha Samadhan
                <span className="absolute left-1/2 -translate-x-1/2 top-full border-4
                  border-transparent border-t-gray-900" />
              </div>
            </div>

            {/* Button (closed state) */}
            <div className="relative">
              <span className="absolute inset-0 rounded-full bg-purple-500 animate-ping opacity-20
                pointer-events-none" />
              <button
                onClick={() => setOpen(true)}
                className="relative w-14 h-14 rounded-full flex items-center justify-center
                  shadow-lg hover:shadow-xl transition-transform duration-200
                  hover:scale-110 active:scale-95 focus:outline-none
                  focus:ring-2 focus:ring-purple-400 focus:ring-offset-2"
                style={{ background: "linear-gradient(135deg,#7C3AED 0%,#4F46E5 60%,#2563EB 100%)" }}
                aria-label="Open Samiksha Samadhan AI Copilot"
              >
                {/* KVS Logo instead of Bot icon */}
                <div className="w-9 h-9 rounded-full bg-white flex items-center justify-center p-1.5 shadow-sm">
                  <img src={kvsLogo} alt="KVS Logo" className="w-full h-full object-contain" />
                </div>
                {/* Online dot */}
                <span className="absolute top-0.5 right-0.5 w-3.5 h-3.5 bg-green-400
                  rounded-full border-2 border-white shadow-sm" />
              </button>
            </div>

            {/* Label */}
            <span className="text-xs font-semibold text-gray-600 bg-white rounded-full
              px-2.5 py-0.5 shadow border border-gray-100 whitespace-nowrap">
              Ask Samiksha
            </span>
          </div>
        )}

        {/* Button (open state — close trigger) */}
        {open && (
          <button
            onClick={() => setOpen(false)}
            className="w-14 h-14 rounded-full flex items-center justify-center
              shadow-lg hover:shadow-xl transition-all duration-200
              hover:scale-110 active:scale-95 focus:outline-none
              bg-gray-700 hover:bg-gray-800"
            aria-label="Close Samiksha Samadhan"
          >
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </>
  );
};

export default FloatingAIButton;
